
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import { types } from 'mobx-state-tree'
import Character from '@/models/Character'
import Effect from '@/components/Effect'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"effect-component"}}>{`Effect Component`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const character = Character.create({\n    attributes: [{ name: \'Armor Rating\' }, { name: \'Charisma\' }],\n    resources: [{ current: 16, name: \'Mana\', maximum: 25 }],\n    spells: [\n      {\n        costs: [{ amount: 8, resource: \'Mana\' }],\n        name: \'Spell-Shield of the Magi\',\n        description:\n          \'A powerful shielding spell, which cloaks the enchanted in radiance.\',\n        effects: [\n          { modifier: 4, modifies: \'Armor Rating\' },\n          { modifier: 2, modifies: \'Charisma\' },\n        ],\n        isActive: true,\n        level: 7,\n      },\n    ],\n  })\n  return <Effect model={character.spells.at(0).effects.at(0)} />\n}'} __scope={{props: this ? this.props : props,types,Character,Effect}}>
  {() => {
    const character = Character.create({
      attributes: [
        { name: 'Armor Rating' },
        { name: 'Charisma' },
      ],
      resources: [
        { current: 16, name: 'Mana', maximum: 25 },
      ],
      spells: [{
        costs: [
          { amount: 8, resource: 'Mana' }
        ],
        name: 'Spell-Shield of the Magi',
        description: 'A powerful shielding spell, which cloaks the enchanted in radiance.',
        effects: [
          { modifier: 4, modifies: 'Armor Rating' },
          { modifier: 2, modifies: 'Charisma' },
        ],
        isActive: true,
        level: 7,
      }],
    })
return <Effect model={character.spells.at(0).effects.at(0)} />
  }}
</Playground>
           </MDXTag>
  }
}
  